"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _useNav = require("../hooks/useNav");

var _NavCollapsedXItem = _interopRequireDefault(require("./NavCollapsedXItem"));

var _NavExpandedItem = _interopRequireDefault(require("./NavExpandedItem"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Item(props) {
  var navVariant = props.navVariant;

  switch (navVariant) {
    case _useNav.NAV_EXPANDED_STATES.EXPANDED:
      return _react.default.createElement(_NavExpandedItem.default, props);

    case _useNav.NAV_EXPANDED_STATES.COLLAPSED_X:
      return _react.default.createElement(_NavCollapsedXItem.default, props);

    case _useNav.NAV_EXPANDED_STATES.COLLAPSED_XY:
    default:
      return null;
  }
}

var _default = Item;
exports.default = _default;